module.exports = __webpack_public_path__ + "static/media/10102020-haywire-weekend-bali.9ad72461.mp4";